import SpecificButton from "../../atoms/specificButton/SpecificButton";
import { LanguageContext } from "../../utils/context/languageContext";
import { GenderType } from "../../utils/enums";
import { LanguageKeys } from "../../utils/languageKeys";
import { handleErrorMessage } from "../../utils/utils";
import { ArrowRight } from "lucide-react";
import React, { useContext, useState } from "react";
import { useConfig } from "../../utils/context/configContext";

interface GenderStepProps {
	onComplete: (value: any) => void;
	initialValue?: any;
	onStepComplete?: (value: any) => Promise<void> | void;
}

const GenderStep = ({ onComplete, initialValue, onStepComplete }: GenderStepProps) => {
	const [genderType, setGenderType] = useState<GenderType>(initialValue);
	const [message, setMessage] = React.useState<string | undefined>(undefined);
	const [loading, setLoading] = React.useState(false);
	const { translate } = useContext(LanguageContext) || {};
	const config = useConfig();
	const input = config?.style?.input;
	const priority = input?.priority;

	const bgColor = priority?.inputBackgroundColor || input?.inputBackgroundColor || "#F9FAFC";
	const textColor = priority?.inputTextColor || input?.inputTextColor || "#000";
	const selectedBgColor = priority?.inputBackgroundColorSelect;
	const selectedTextColor = priority?.inputBackgroundColorSelectTextColor;

	const handleNext = async () => {
		setLoading(true);
		setMessage(undefined);
		try {
			await onStepComplete?.(genderType);
			onComplete?.(genderType);
		} catch (error) {
			setMessage(handleErrorMessage(error));
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<div className=" w-full flex flex-col max-w-md mt-[3.5rem] mb-[.75rem] gap-[1rem]">
				<button
					data-testid="onboarding-gender-male"
					className={` text-btnSize  bg-btn  cursor-pointer  border  leading-none  rounded-[.375rem]     focus-visible:ring-secondary p-[1rem] ${
						genderType === GenderType.Male ? ` shadow-[0_1px_1px_rgba(0,0,0,0.251)]` : ""
					}`}
					onClick={() => {
						setGenderType(GenderType.Male);
						setMessage(undefined);
					}}
					style={{
						background: genderType === GenderType.Male ? selectedBgColor : bgColor,
						color: genderType === GenderType.Male ? selectedTextColor : textColor,
						fontSize: input?.inputFontSize || "16px",
						fontWeight: input?.inputFontWeight || "400",
						border: `1px solid ${genderType === GenderType.Male ? config?.style?.base?.primaryColor : `transparent`}`,
						fontFamily: config?.style?.base?.baseFontFamily || "Inter, sans-serif",
						borderRadius: input?.inputBorderRadius || "4px",
					}}
				>
					{translate?.(LanguageKeys.mens)}
				</button>
				<button
					data-testid="onboarding-gender-female"
					className={`text-btnSize font-btnFont cursor-pointer   leading-none  rounded-[.375rem]      focus-visible:ring-secondary p-[1rem] ${
						genderType === GenderType.Female ? ` shadow-[0_1px_1px_rgba(0,0,0,0.251)]` : ""
					}`}
					onClick={() => {
						setGenderType(GenderType.Female);
						setMessage(undefined);
					}}
					style={{
						background: genderType === GenderType.Female ? selectedBgColor : bgColor,
						color: genderType === GenderType.Female ? selectedTextColor : textColor,
						fontSize: input?.inputFontSize || "16px",
						fontWeight: input?.inputFontWeight || "400",
						border: `1px solid ${genderType === GenderType.Female ? config?.style?.base?.primaryColor : `transparent`}`,
						fontFamily: config?.style?.base?.baseFontFamily || "Inter, sans-serif",
						borderRadius: input?.inputBorderRadius || "4px",
					}}
				>
					{translate?.(LanguageKeys.womens)}
				</button>
				{message && (
					<p
						className="mt-[0.2rem]"
						style={{
							color: input?.inputErrorColor || "#000",
							fontSize: input?.inputErrorFontSize || "16px",
						}}
					>
						{message}
					</p>
				)}
			</div>
			<div className="flex justify-end mt-[.5rem]">
				<SpecificButton
					type="submit"
					data-testid="onboarding-next-btn"
					buttonText={translate?.(LanguageKeys.next)}
					postfixIcon={<ArrowRight size={14} />}
					disabled={!genderType || loading}
					buttonFunc={handleNext}
				/>
			</div>
		</>
	);
};

export default GenderStep;
